import { motion } from "framer-motion";
import CONSTANT from "../../constants/constant";
import ToastContainer from "./Toast.styled";
import { useStatus } from "../../contexts/statusContext";

const Toast = () => {
  const { statusKey } = useStatus();

  return (
    <ToastContainer
      as={motion.div}
      initial={{ opacity: 0, y: statusKey ? "80px" : "0" }}
      animate={{ opacity: 1, y: statusKey ? "0" : "80px" }}
      transition={{
        type: "spring",
        damping: 60,
        mass: 1,
        stiffness: 200,
      }}
    >
      {CONSTANT.STATUS_VALUE[statusKey]}
    </ToastContainer>
  );
};

export default Toast;
